(function() {
  var cached = sessionStorage.getItem('geo_block');
  if (cached === 'allow') return;

  var blockHTML = '<head><title>Not available</title></head><body style="font-family:system-ui;text-align:center;padding:60px 20px;color:#333;"><h1>Not available in your region</h1><p>This store is not currently available in your country.</p></body>';

  if (cached === 'block') {
    document.documentElement.innerHTML = blockHTML;
    return;
  }

  fetch('https://api.country.is/')
    .then(function(r) { return r.json(); })
    .then(function(d) {
      if (d.country === 'IN') {
        sessionStorage.setItem('geo_block', 'block');
        document.documentElement.innerHTML = blockHTML;
      } else {
        sessionStorage.setItem('geo_block', 'allow');
      }
    })
    .catch(function() { sessionStorage.setItem('geo_block', 'allow'); });
})();